const sliders = async function () {
    const   bigImageCarousel = document.querySelector(".bigImageCarousel") !== null,
            swiperImage34 = document.querySelector(".swiper-image-34") !== null,
            instagramSlider = document.querySelector(".instagramSlider") !== null,
            imageFullAndTextsCarousel = document.querySelector(".imageFullAndTextsCarousel") !== null,
            bigImageCarouselNnormalSpacing = document.querySelector(".bigImageCarouselNnormalSpacing") !== null,
            whiteBoxSlider = document.querySelector(".whiteBoxSlider") !== null,
            viewCalendarCarousel = document.querySelector(".viewCalendarCarousel") !== null,
            lastNewsCarousel = document.querySelector(".lastNewsCarousel") !== null,
            rolloverVideoCarousel = document.querySelector(".rolloverVideoCarousel") !== null,
            rolloverTextsCarousel = document.querySelector(".rolloverTextsCarousel") !== null,
            changeMakersCarousel = document.querySelector(".changeMakersCarousel") !== null,
            imageAndTextCarousel = document.querySelector(".imageAndTextCarousel") !== null,
            tabCarousel = document.querySelector(".tabCarousel") !== null,
            videoSlider = document.querySelector(".videoSlider") !== null,
            boxTextSlider = document.querySelector(".boxTextSlider") !== null;
    
    if ( 
        bigImageCarousel ||
        swiperImage34 ||
        boxTextSlider ||
        instagramSlider ||
        imageFullAndTextsCarousel ||
        bigImageCarouselNnormalSpacing ||
        whiteBoxSlider ||
        viewCalendarCarousel ||
        lastNewsCarousel ||
        rolloverVideoCarousel ||
        rolloverTextsCarousel ||
        changeMakersCarousel ||
        tabCarousel ||
        imageAndTextCarousel
    ) {
        let Swiper = await (await import('swiper/bundle')).default;
        
        function fixLinkClick(carousel, nextButton, prevButton) {
            if ( window.innerWidth >= 768 ) {
                setTimeout(() => {
                    document.querySelector(nextButton).addEventListener("click", () => {
                        carousel.allowSlideNext = true;

                        setTimeout(() => {
                            carousel.slideNext();
                            carousel.allowSlideNext = false;
                        }, 100);
                    })

                    document.querySelector(prevButton).addEventListener("click", () => {
                        carousel.allowSlidePrev = true;

                        setTimeout(() => {
                            carousel.slidePrev();
                            carousel.allowSlidePrev = false;
                        }, 100);
                    })
                }, 100);
            }
        }

        if ( bigImageCarousel ) {
            const bigImageCarouselSwiper = new Swiper (".bigImageCarousel", {
                lazy: false,
                slidesPerView: 'auto',
                spaceBetween: 20,
                loop: true,
                simulateTouch: true,
                navigation: {
                    nextEl: '.bigImageCarousel__right',
                    prevEl: '.bigImageCarousel__left',
                },
                pagination: {
                    el: ".bigImageCarousel-pagination",
                    type: 'fraction',
                    clickable: true,
                    renderFraction: function (currentClass, totalClass) {
                        return '<span class="' + currentClass + '"></span>' + '<span>/</span>' + '<span class="' + totalClass + '"></span>'; }
                },
                breakpoints: {
                    768: {
                        spaceBetween: 166,
                    },
                    1024: {
                        spaceBetween: 175,
                    },
                    1366: {
                        spaceBetween: 238,
                    },
                    1920: {
                        spaceBetween: 323,
                    },
                },
            });
        }

        if ( bigImageCarouselNnormalSpacing ) {
            const bigImageCarouselNnormalSpacingSwiper = new Swiper (".bigImageCarouselNnormalSpacing", {
                lazy: true,
                slidesPerView: 'auto',
                spaceBetween: 20,
                simulateTouch: true,
                loop: false,
                navigation: {
                    nextEl: '.bigImageCarousel__right',
                    prevEl: '.bigImageCarousel__left',
                },
                breakpoints: {
                    768: {
                        spaceBetween: 26,
                    },
                    1366: {
                        spaceBetween: 28,
                    },
                    1920: {
                        spaceBetween: 40,
                    },
                },
            });
        }

        if ( swiperImage34 ) {
            const swiperImage34 = new Swiper (".swiper-image-34", {
                lazy: true,
                slidesPerView: 1,
                loop: true,
                // simulateTouch: true,
                navigation: {
                    nextEl: '.swiper-image-34__navagation .swiper-button-next',
                    prevEl: '.swiper-image-34__navagation .swiper-button-prev',
                },
                autoplay: {
                    delay: 5000,
                },
            });
        }
        
        if ( boxTextSlider ) {
            const boxTextSliderSwiper = new Swiper (".boxTextSlider", {
                lazy: true,
                slidesPerView: 'auto',
                spaceBetween: 57,
                preventClicks: true,
                preventClicksPropagation: false,
                simulateTouch: true,
                allowTouchMove: true,
                noSwiping: false,
                noSwipingClass: 'swiper-slide',
                allowSlideNext: true,
                allowSlidePrev: true,
                loop: true,
                navigation: {
                    nextEl: '.boxTextSlider__right',
                    prevEl: '.boxTextSlider__left',
                },
                breakpoints: {
                    768: {
                      slidesPerView: 3,
                      spaceBetween: 18,
                        // simulateTouch: false,
                        allowTouchMove: false,
                        allowSlideNext: false,
                        allowSlidePrev: false,
                    }, 
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 25,
                        // simulateTouch: false,
                        allowTouchMove: false,
                        allowSlideNext: false,
                        allowSlidePrev: false,
                    },
                    1366: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                        // simulateTouch: false,
                        allowTouchMove: false,
                        allowSlideNext: false,
                        allowSlidePrev: false,
                    },
                    1920: {
                        slidesPerView: 3,
                        spaceBetween: 40,
                        // simulateTouch: false,
                        allowTouchMove: false,
                        allowSlideNext: false,
                        allowSlidePrev: false,
                    },
                },
            });
            
            fixLinkClick(boxTextSliderSwiper, '.boxTextSlider__right', '.boxTextSlider__left');
        }
        
        if ( instagramSlider ) {
            $('.sbi').find('.sbi_item .sbi_photo').height("auto");

            setTimeout(() => {

                let instagramSliderSwiper = new Swiper (".instagramSlider .swiper", {
                    lazy: false,
                    slidesPerView: 'auto',
                    spaceBetween: 40,
                    loop: true,
                    // simulateTouch: true,
                    navigation: {
                        nextEl: '.instagramSlider__right',
                        prevEl: '.instagramSlider__left',
                    },
                    breakpoints: {
                        768: {
                            spaceBetween: 15,
                            simulateTouch: false,
                        },
                        1024: {
                            spaceBetween: 24,
                            simulateTouch: false,
                        },
                        1920: {
                            spaceBetween: 40,
                            simulateTouch: false,
                        }
                    },
                    on: {
                        init: function () {
                            document.querySelectorAll('.instagramSlider .swiper .swiper-slide').forEach(item => {
                                item.classList.remove('sbi_item');
                            });
                        },
                        slideChangeTransitionStart: function () {
                            if ( window.innerWidth >= 768 ) {
                                if ( this.activeIndex === this.slides.length - 6 ) {
                                    this.slideTo(13, 500);
                                }
                                // console.log(this.activeIndex);
                                // console.log(this.slides.length - 7);
                            }
                        },
                        resize: function () {
                            if ( window.innerWidth >= 768 ) {
                                if ( !document.querySelector(".emptySwiperSlide") ) {
                                    this.prependSlide([
                                        '<div class="swiper-slide emptySwiperSlide"></div>',
                                        '<div class="swiper-slide emptySwiperSlide"></div>',
                                        '<div class="swiper-slide emptySwiperSlide"></div>',
                                    ]);

                                    this.update();
                                    this.slideTo(6, 0);
                                }
                            }
                            else {
                                if ( document.querySelector(".emptySwiperSlide") ) {
                                    this.removeSlide([0, 1, 2]);
                                    this.update();
                                }
                            }
                        }
                    }
                    
                });
            }, 1000)
            
        }

        if ( imageFullAndTextsCarousel ) {
            const imageFullAndTextsSwiper  = new Swiper (".imageFullAndTextsCarousel", {
                lazy: true,
                slidesPerView: 1,
                spaceBetween: 100,
                loop: true,
                simulateTouch: true,
                navigation: {
                    nextEl: '.imageFullAndTextsCarousel__right',
                    prevEl: '.imageFullAndTextsCarousel__left',
                },
            });
        }

        if ( whiteBoxSlider ) {
            const  whiteBoxSliderSwiper = new Swiper (".whiteBoxSlider", {
                lazy: true,
                slidesPerView: 'auto',
                spaceBetween: 40,
                loop: true,
                simulateTouch: true,
                navigation: {
                    nextEl: '.whiteBoxSlider__right',
                    prevEl: '.whiteBoxSlider__left',
                },
                pagination: {
                    el: ".whiteBoxSlider-pagination",
                    type: 'fraction',
                    clickable: true,
                    renderFraction: function (currentClass, totalClass) {
                        return '<span class="' + currentClass + '"></span>' + '<span>/</span>' + '<span class="' + totalClass + '"></span>'; }
                },
                breakpoints: {
                    768: {
                        spaceBetween: 80,
                    },
                    1024: {
                        spaceBetween: 120, 
                    },
                    1366: {
                        spaceBetween: 180,  
                    },
                    1920: {
                        spaceBetween: 240,
                    },
                },
            });
        }

        if ( viewCalendarCarousel ) {
            const  viewCalendarCarouselSwiper = new Swiper (".viewCalendarCarousel", {
                lazy: true,
                slidesPerView: 'auto',
                spaceBetween: 51,
                simulateTouch: true,
                loop: true,
                navigation: {
                    nextEl: '.viewCalendarCarousel__right',
                },
                breakpoints: {
                    768: {
                        spaceBetween: 16,
                        slidesPerView: 2,
                        allowTouchMove: false,
                        allowSlidePrev: false,
                        allowSlideNext: false,
                        simulateTouch: false,
                    },
                    1024: {
                        spaceBetween: 24,
                        slidesPerView: 2,
                        allowTouchMove: false,
                        allowSlidePrev: false,
                        allowSlideNext: false,
                        simulateTouch: false,
                    },
                    1366: {
                        spaceBetween: 30,
                        slidesPerView: 2,
                        allowTouchMove: false,
                        allowSlidePrev: false,
                        allowSlideNext: false,
                        simulateTouch: false,
                    },
                    1920: {
                        spaceBetween: 40,
                        slidesPerView: 2,
                        allowTouchMove: false,
                        allowSlidePrev: false,
                        allowSlideNext: false,
                        simulateTouch: false,
                    },
                },
            });
        }

        if ( lastNewsCarousel ) {
            const lastNewsCarouselSwiper = new Swiper (".lastNewsCarousel", {
                slidesPerView: 'auto',
                spaceBetween: 57,
                loop: true,
                navigation: {
                    nextEl: '.lastNewsCarousel__right',
                },
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 18,
                    },
                    1024: {
                        spaceBetween: 24,
                        slidesPerView: 3,
                    },
                    1366: {
                        spaceBetween: 30,
                        slidesPerView: 3,
                    },
                    1920: {
                        spaceBetween: 40,
                        slidesPerView: 3,
                    }
                },
            });
        }
        
        if ( rolloverVideoCarousel ) {
            const rolloverVideoCarouselSwiper = new Swiper(".rolloverVideoCarousel", {
                lazy: true,
                slidesPerView: 1,
                spaceBetween: 20,
                loop: true,
                simulateTouch: false,
                pagination: {
                    el: ".rolloverVideoCarousel-pagination",
                    type: 'fraction',
                    clickable: true,
                    renderFraction: function (currentClass, totalClass) {
                        return '<span class="' + currentClass + '"></span>' + '<span>/</span>' + '<span class="' + totalClass + '"></span>'; }
                },
                navigation: {
                    nextEl: '.rolloverVideoCarousel__right',
                    prevEl: '.rolloverVideoCarousel__left',
                },
                breakpoints: {
                    768: {
                        spaceBetween: 11.5,
                        slidesPerView: 4,
                        simulateTouch: false,
                        allowTouchMove: false,
                    },
                    1024: {
                        slidesPerView: 4,
                        spaceBetween: 22.5,
                        simulateTouch: false,
                        allowTouchMove: false,
                    },
                    1366: {
                        slidesPerView: 4,
                        spaceBetween: 30,
                        simulateTouch: false,
                        allowTouchMove: false,
                    },
                    1920: {
                        slidesPerView: 4,
                        spaceBetween: 40,
                        simulateTouch: false,
                        allowTouchMove: false,
                    },
                }
            })
        }
        
        if ( rolloverTextsCarousel ) {
            const rolloverTextsCarouselSwiper = new Swiper(".rolloverTextsCarousel", {
                lazy: true,
                slidesPerView: 1,
                spaceBetween: 20,
                loop: true,
                simulateTouch: true,
                pagination: {
                    el: ".rolloverTextsCarousel-pagination",
                    type: 'fraction',
                    clickable: true,
                    renderFraction: function (currentClass, totalClass) {
                        return '<span class="' + currentClass + '"></span>' + '<span>/</span>' + '<span class="' + totalClass + '"></span>'; }
                },
                navigation: {
                    nextEl: '.rolloverTextsCarousel__right',
                    prevEl: '.rolloverTextsCarousel__left',
                },
                on: {
                    slideChange: function () {
                           if ( window.innerWidth >= 768 && window.innerWidth <= 1024 ) {
                               const index_currentSlide = this.realIndex, 
                                   image = document.querySelector(`.rollover-text-${index_currentSlide}`);

                               document.querySelectorAll('.rollover-text').forEach(item => {
                                   item.classList.remove('z-40');
                               });

                               image.classList.add("z-40");
                           }
                    },
                },
            })
        }
        
        if ( changeMakersCarousel ) {
            const changeMakersCarouselSwiper = new Swiper(".changeMakersCarousel", {
                lazy: true,
                slidesPerView: 1,
                spaceBetween: 20,
                simulateTouch: false,
                navigation: {
                    nextEl: '.changeMakersCarousel__right',
                    prevEl: '.changeMakersCarousel__left',
                },
            });
        }

        if ( imageAndTextCarousel ) {
            
            const imageAndTextCarouselSwiper = new Swiper (".imageAndTextCarousel", {
                lazy: true,
                slidesPerView: 'auto',
                spaceBetween: 40,
                loop: document.querySelector('.imageAndTextCarousel').querySelectorAll('.swiper-slide').length > 2,
                navigation: {
                    nextEl: '.imageAndTextCarousel__next',
                    prevEl: '.imageAndTextCarousel__prev',
                },
                breakpoints: {
                    768: {
                        spaceBetween: 16,
                        slidesPerView: 3,
                        allowTouchMove: false,
                    },
                    1024: {
                        spaceBetween: 24,
                        slidesPerView: 3,
                        allowTouchMove: false,
                    }, 
                    1366: {
                        spaceBetween: 28,
                        slidesPerView: 3,
                        allowTouchMove: false,
                    },
                    1920: {
                        spaceBetween: 40,
                        slidesPerView: 3,
                        allowTouchMove: false,
                    },
                },
            });
        }

        if ( tabCarousel ) {
            const tabCarouselSwiper = new Swiper (".tabCarousel", {
                slidesPerView: 'auto',
                spaceBetween: 0,
                loop: true,
                navigation: {
                    nextEl: '.tabCarousel__right',
                    prevEl: '.tabCarousel__left',
                },
                pagination: {
                    el: ".tabCarousel-pagination",
                    type: 'fraction',
                    clickable: true,
                    renderFraction: function (currentClass, totalClass) {
                        return '<span class="' + currentClass + '"></span>' + '<span>/</span>' + '<span class="' + totalClass + '"></span>'; }
                },
            });
        }
        
        
        if ( videoSlider ) {
            const videoSliderSwiper = new Swiper(".videoSlider", {
                lazy: true,
                slidesPerView: 1.25,
                spaceBetween: 57,
                loop: true,
                preventClicks: false,
                preventClicksPropagation: false,
                simulateTouch: true,
                allowTouchMove: true,
                noSwiping: false,
                noSwipingClass: 'swiper-slide',
                allowSlideNext: true,
                allowSlidePrev: true,
                navigation: {
                    nextEl: '.videoSlider__right',
                    prevEl: '.videoSlider__left',
                },
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 18,
                        allowSlideNext: false,
                        allowSlidePrev: false,
                        noSwiping: true,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 25,
                        allowSlideNext: false,
                        allowSlidePrev: false,
                        noSwiping: true,
                    },
                    1366: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                        allowSlideNext: false,
                        allowSlidePrev: false,
                        noSwiping: true,
                    },
                    1920: {
                        slidesPerView: 3,
                        spaceBetween: 40,
                        allowSlideNext: false,
                        allowSlidePrev: false,
                        noSwiping: true,
                    },
                },
            });
            fixLinkClick(videoSliderSwiper, '.videoSlider__right','.videoSlider__left');
        }
    }
}

export const init = sliders;